import apiClient from './client';

type PairStartResponse = {
  success: boolean;
  data: {
    pair_code: string;
    expires_at: string;
  } | null;
  error: string | null;
};

type PairStatusResponse = {
  success: boolean;
  data: {
    authenticated: boolean;
    access_token?: string;
    user_id?: number;
  } | null;
  error: string | null;
};

/**
 * Start the pairing flow. Sends the TV's UUID to the backend,
 * which returns an 8-digit pair code for the user to enter on their phone.
 */
export async function startPairing(tvUuid: string): Promise<PairStartResponse> {
  const response = await apiClient.post('/tv/pair/start', { tv_uuid: tvUuid });
  return response.data;
}

/**
 * Check the status of the pairing. If the mobile user has confirmed the code,
 * the backend returns an access token (one-time retrieval).
 */
export async function checkPairStatus(
  tvUuid: string,
): Promise<PairStatusResponse> {
  const response = await apiClient.post('/tv/pair/status', {
    tv_uuid: tvUuid,
  });
  return response.data;
}
